<template>
	<div id="usewater">
		<div class="title">日用水量</div>
		<div id="mydom" ref="myEcharts"></div>
	</div>
</template>

<script>
	import * as echarts from "echarts";
//	import axios from "axios";
	export default {
		data() {
			return {
				xAxisData: [],
				yAxisData: [],
				xdata: [],
				ydata: [],
				num: 0,
			};
		},
		mounted() {
			//进来请求溢一次数据
			this.getdata();
			//设置每隔10分钟请求一次数据
			setInterval(() => {
				this.getdata();
			}, 600000)
			this.myecharts();
			// setInterval(()=>{
			//   this.xAxisData.forEach((item,index)=>{
			//     if(index>this.num&&index<this.num+10){
			//       this.xdata.push(item)
			//       console.log(this.xdata)
			//     }
			//   })
			//   this.yAxisData.forEach((item,index)=>{
			//     if(index>this.num&&index<this.num+10){
			//       this.ydata.push(item)
			//       console.log(this.ydata)
			//     }
			//   })

			//   this.num=this+10
			//   this.myecharts()
			// },5000)
		},
		methods: {
			getdata() {
				// 获取数据
//				var params = new URLSearchParams();
//				params.append("deptId", "892");
//				params.append("checkCode", "3F55CAEAEAA1261CEFB7369CB6987DDB");
//				axios.post("/api/data/getDayRealTimeWater", params)
//					.then((res) => {
						//获取点位数据
						this.yAxisData = [2.0, 4.0, 4.0, 11.0, 1.0, 0.0,4.0,2.0,2.0,2.0,1.0,0.0,3.0,3.0,2.0,2.0,3.0,2.0,3.0,3.0,2.0,3.0,2.0,3.0,3.0,3.0,3.0,2.0,3.0,5.0,6.0,5.0,6.0,4.0,1.0,4.0,3.0,5.0,3.0,1.0,3.0,0.0,3.0,0.0,3.0,3.0,3.0,1.0,3.0,2.0,4.0,5.0,4.0,2.0,3.0,2.0,2.0,3.0,3.0,0.0,2.0,3.0,0.0,4.0,2.0,2.0,3.0,3.0,1.0,3.0,3.0,2.0,3.0,2.0,4.0,2.0,3.0,3.0,4.0,2.0,1.0,2.0,4.0,4.0,2.0,3.0,1.0,3.0,3.0,5.0,3.0,2.0,2.0,2.0,7.0,0.0,2.0,2.0,2.0,3.0,4.0,5.0,3.0,3.0,8.0,7.0,7.0,1.0,4.0,4.0,2.0,3.0,2.0,1.0,3.0,3.0,3.0,2.0,2.0,2.0,3.0,3.0,3.0,3.0,3.0,2.0,3.0,3.0,1.0,2.0,2.0,3.0,4.0,5.0,3.0,3.0,2.0,2.0,2.0,3.0,1.0,2.0,3.0,2.0,2.0,3.0,3.0,3.0,3.0,3.0,4.0,6.0,3.0,3.0,4.0,3.0,2.0,4.0,2.0,2.0,2.0,3.0,3.0,3.0,3.0,4.0,2.0,3.0,2.0,2.0,3.0,1.0,2.0,2.0,1.0,2.0,3.0,8.0,3.0,2.0,1.0,3.0,2.0,0.0,2.0,3.0,2.0,2.0,2.0,4.0,3.0,3.0,2.0,1.0,2.0,2.0,1.0,1.0,3.0,1.0,2.0,3.0,2.0,2.0,3.0,1.0,2.0,0.0,0.0,3.0,3.0,2.0,3.0,3.0,2.0,2.0,3.0,2.0,4.0,3.0,2.0,2.0,3.0,3.0,1.0,2.0,2.0,3.0,3.0,2.0,3.0,3.0,4.0,2.0,2.0,3.0,3.0,2.0,2.0,3.0,3.0,2.0,2.0,2.0,4.0,3.0,4.0,3.0,2.0,5.0,3.0,3.0,2.0,3.0,3.0,2.0,2.0,2.0,2.0,3.0,3.0,3.0,2.0,2.0,2.0,3.0,2.0,3.0,3.0,2.0,3.0,3.0,3.0,3.0,3.0,3.0,3.0,1.0,3.0,3.0,1.0,2.0,2.0,2.0,3.0,2.0,3.0,3.0,2.0,3.0,4.0,3.0,3.0,2.0,2.0,3.0,2.0,3.0,3.0,3.0,2.0,3.0,3.0,3.0,3.0,4.0,2.0,2.0,2.0,2.0,0.0,2.0,2.0,2.0,2.0,3.0,3.0,1.0,2.0,2.0,3.0,3.0,3.0,4.0,2.0,3.0,2.0,2.0,3.0,2.0,2.0,3.0,3.0,1.0,3.0,3.0,2.0,0.0,2.0,3.0,1.0,4.0,3.0,3.0,3.0,3.0,3.0,1.0,2.0,3.0,3.0,3.0,1.0,2.0,1.0,3.0,2.0,2.0,2.0,3.0,2.0,3.0,3.0,4.0,0.0,3.0,4.0,2.0,3.0,2.0,6.0,3.0,3.0,1.0,3.0,1.0,2.0,4.0,5.0,3.0,3.0,3.0,3.0,4.0,3.0,2.0,2.0,4.0,3.0,3.0,4.0,4.0,5.0,6.0,3.0,5.0,3.0,3.0,6.0,3.0,4.0,3.0,5.0,4.0,3.0,4.0,4.0,5.0,3.0,4.0,7.0,4.0,5.0,3.0,2.0,4.0,3.0,4.0,4.0,4.0,5.0,4.0,3.0,3.0,3.0,1.0,5.0,7.0,7.0,11.0,3.0,3.0,8.0,12.0,5.0,5.0,5.0,5.0,7.0,5.0,5.0,6.0,4.0,1.0,-16.0,-11.0,-13.0,-12.0,-11.0,-9.0,-10.0,-8.0,-7.0,-5.0];
						this.xAxisData = ["10:17", "10:23", "10:29", "10:30", "10:35", "10:36", "10:41", "10:42", "10:47", "10:48", "10:54", "10:55", "11:00", "11:01", "11:06", "11:07", "11:12", "11:13", "11:18", "11:19", "11:25", "11:31", "11:32", "11:37", "11:38", "11:43", "11:44", "11:49", "11:50", "11:56", "12:02", "12:03", "12:08", "12:09", "12:14", "12:15", "12:20", "12:21", "12:27", "12:33", "12:34", "12:39", "12:40", "12:45", "12:46", "12:51", "12:52", "12:58", "13:04", "13:05", "13:10", "13:11", "13:16", "13:17", "13:22", "13:23", "13:28", "13:29", "13:35", "13:36", "13:41", "13:42", "13:47", "13:48", "13:53", "13:54", "13:59", "14:00", "14:06", "14:07", "14:12", "14:13", "14:18", "14:19", "14:24", "14:25", "14:30", "14:31", "14:37", "14:43", "14:44", "14:49", "14:50", "14:55", "14:56", "15:01", "15:02", "15:07", "15:08", "15:14", "15:15", "15:20", "15:21", "15:26", "15:27", "15:32", "15:33", "15:38", "15:39", "15:45", "15:51", "15:52", "15:57", "15:58", "16:03", "16:04", "16:09", "16:10", "16:15", "16:16", "16:22", "16:23", "16:28", "16:29", "16:34", "16:35", "16:40", "16:41", "16:46", "16:47", "16:53", "16:54", "16:59", "17:00", "17:05", "17:06", "17:11", "17:12", "17:17", "17:18", "17:24", "17:25", "17:30", "17:31", "17:36", "17:37", "17:42", "17:43", "17:49", "17:55", "17:56", "18:01", "18:02", "18:07", "18:08", "18:13", "18:14", "18:20", "18:26", "18:27", "18:32", "18:33", "18:38", "18:39", "18:44", "18:45", "18:50", "18:51", "18:57", "18:58", "19:03", "19:04", "19:09", "19:10", "19:15", "19:16", "19:21", "19:22", "19:28", "19:34", "19:35", "19:40", "19:41", "19:46", "19:47", "19:52", "19:53", "19:59", "20:05", "20:06", "20:11", "20:12", "20:17", "20:18", "20:23", "20:24", "20:30", "20:36", "20:37", "20:42", "20:43", "20:48", "20:49", "20:54", "20:55", "21:01", "21:02", "21:07", "21:08", "21:13", "21:14", "21:19", "21:20", "21:25", "21:26", "21:32", "21:33", "21:38", "21:39", "21:44", "21:45", "21:50", "21:51", "21:56", "21:57", "22:03", "22:09", "22:10", "22:15", "22:16", "22:21", "22:22", "22:27", "22:28", "22:34", "22:40", "22:41", "22:46", "22:47", "22:52", "22:53", "22:58", "22:59", "23:04", "23:05", "23:11", "23:12", "23:17", "23:18", "23:23", "23:29", "23:30", "23:35", "23:36", "23:42", "23:43", "23:48", "23:49", "23:54", "23:55", "00:00", "00:01", "00:07", "00:13", "00:14", "00:19", "00:20", "00:25", "00:26", "00:31", "00:32", "00:38", "00:44", "00:45", "00:50", "00:51", "00:56", "00:57", "01:02", "01:03", "01:09", "01:15", "01:16", "01:21", "01:22", "01:27", "01:28", "01:33", "01:34", "01:40", "01:46", "01:47", "01:52", "01:53", "01:58", "01:59", "02:04", "02:05", "02:11", "02:12", "02:17", "02:18", "02:23", "02:24", "02:29", "02:30", "02:35", "02:36", "02:42", "02:43", "02:48", "02:49", "02:54", "02:55", "03:00", "03:01", "03:07", "03:13", "03:14", "03:19", "03:20", "03:25", "03:26", "03:31", "03:32", "03:38", "03:44", "03:45", "03:50", "03:51", "03:56", "03:57", "04:02", "04:03", "04:09", "04:15", "04:16", "04:21", "04:22", "04:27", "04:28", "04:33", "04:34", "04:40", "04:41", "04:46", "04:47", "04:52", "04:53", "04:58", "04:59", "05:04", "05:05", "05:11", "05:12", "05:17", "05:18", "05:23", "05:24", "05:29", "05:30", "05:35", "05:36", "05:42", "05:43", "05:48", "05:49", "05:54", "05:55", "06:00", "06:01", "06:06", "06:07", "06:13", "06:14", "06:19", "06:20", "06:25", "06:26", "06:31", "06:32", "06:37", "06:38", "06:44", "06:45", "06:50", "06:51", "06:56", "06:57", "07:02", "07:03", "07:08", "07:09", "07:15", "07:16", "07:21", "07:22", "07:27", "07:28", "07:33", "07:34", "07:40", "07:46", "07:47", "07:52", "07:53", "07:58", "07:59", "08:04", "08:05", "08:11", "08:17", "08:18", "08:23", "08:24", "08:29", "08:30", "08:35", "08:36", "08:42", "08:48", "08:49", "08:54", "08:55", "09:00", "09:01", "09:06", "09:07", "09:13", "09:14", "09:19", "09:20", "09:25", "09:26", "09:31", "09:32", "09:37", "09:38", "09:44", "09:50", "09:56", "09:57", "10:02", "10:03", "10:09", "10:15", "10:16", "10:21", "10:22", "10:27", "10:28", "10:33", "10:34", "10:39", "10:40", "10:46", "10:47", "10:52", "10:53", "10:58", "10:59", "11:04", "11:05", "11:10"];
//					})
//					.catch((error) => {
//						console.log(error);
//					});
			},
			myecharts() {
				var Echarts = echarts.init(this.$refs.myEcharts);
				var option = {
					xAxis: {
						type: "category",
						boundaryGap: true,
						data: [],
						// data: this.xAxisData,
						axisLabel: {
							interval: 0, //横轴信息全部显示
							textStyle: {
								color: "white",
							},
						},
					},
					yAxis: {
						type: "value",
						data: [],
						axisLabel: {
							textStyle: {
								color: "white",
							},
						},
						splitLine: {
							show: false, // 不显示网格线
						},
					},
					tooltip: {
						show: true,
						trigger: "item",
						axisPointer: {
							type: "cross",
							label: {
								backgroundColor: "#fec500",
							},
						},
					},
					grid: {
						show: false,
						top: "18%",
						bottom: "23%",
						left: "9%",
						right: "7%",
					},
					animation: true,
					animationDuration: 2000,
					series: [{
						showSymbol: false,
						data: [],
						// data: this.yAxisData,
						type: "line",
						areaStyle: {},
						textStyle: {
							fontSize: "12",
						},
						endLabel: {
							show: true,
							fontWeight: 'normal',
							fontStyle: 'normal',
							color: "#fec500",
							fontSize: 10
						},
						itemStyle: {
							normal: {
								lineStyle: {
									width: "0",

								},
								areaStyle: {
									type: 'default',
									color: "#1e366a"
								}
							},
						},
						smooth: true, //将折线变成平滑的线条，不是直线
						Symbol: "none",
					}, ],
				};
				setInterval(() => {
					this.xAxisData.forEach((item, index) => {
						if(index >= this.num && index <= this.num + 1) {
							this.xdata.push(item);
							if(this.xdata.length > 6) {
								this.xdata.shift()
							}
							// console.log(this.xdata);
						}
					});
					this.yAxisData.forEach((item, index) => {
						if(index >= this.num && index <= this.num + 1) {
							this.ydata.push(item);
							if(this.ydata.length > 6) {
								this.ydata.shift()
							}
							// console.log(this.ydata);
						}
					});
					this.num = this.num + 1;
					if(this.num == this.xAxisData.length) {
						this.num = 0
					}

					Echarts.setOption({
						xAxis: [{
							data: this.xdata,
						}, ],
						series: [{
							data: this.ydata,
						}, ],
					});
				}, 2000);
				Echarts.setOption(option);
			},
		},
	};
</script>

<style scoped>
	#usewater {
		margin-top: 1.48vh;
		height: 21.03vh;
		width: 100%;
		background: url("@/assets/pengshui_bg.png") no-repeat center center;
		background-size: 100% 100%;
		color: #ffffff;
	}
	
	.title {
		color: #ffffff;
		text-align: start;
		height: 3vh;
		line-height: 3vh;
		margin-left: 1.04vw;
		font-size: 18px;
		padding-top: 0.93vh;
	}
	
	#mydom {
		height: 18.52vh;
		width: 17vw;
		cursor: pointer;
		/* border: 1px solid red; */
	}
</style>